import { useState } from 'react';
import { useSession } from '../auth/AuthProvider';
import { roleLabel } from '../labels';

/**
 * Member account management — profile, org switching, the seats you hold, and sign-out.
 * Shared by every module (there is no central app), so it renders entirely from /auth/me.
 */
export function AccountPage() {
  const { me, client, reload, selectOrg, logout } = useSession();
  const [name, setName] = useState(me?.user.name ?? '');
  const [saved, setSaved] = useState(false);
  const [busy, setBusy] = useState(false);

  if (!me) return <p>טוען…</p>;

  async function save() {
    setBusy(true);
    setSaved(false);
    try {
      await client.updateName(name.trim() === '' ? null : name.trim());
      await reload();
      setSaved(true);
    } finally {
      setBusy(false);
    }
  }

  return (
    <div data-testid="account-page">
      <h1>החשבון שלי</h1>

      <section>
        <h2>פרופיל</h2>
        {/* <bdi> isolates the LTR address without flipping the element's own alignment (dir="ltr"
            here would left-align it inside the RTL card). */}
        <p data-testid="account-email">
          <bdi>{me.user.email}</bdi>
        </p>
        <label htmlFor="huaca-name">שם</label>
        <input id="huaca-name" value={name} onChange={(e) => setName(e.target.value)} placeholder="השם שלכם" />
        <button type="button" className="btn-primary" onClick={() => void save()} disabled={busy} data-testid="save-name">
          {busy ? 'שומר…' : 'שמירה'}
        </button>
        {saved && <span role="status">נשמר</span>}
      </section>

      <section>
        <h2>ארגונים</h2>
        <ul>
          {me.orgs.map((org) => (
            <li key={org.id} data-testid={`org-${org.id}`}>
              <span>
                {org.name} — {roleLabel(org.rootRole)}
              </span>
              {org.id === me.org.id ? (
                <span data-testid="current-org"> (נוכחי)</span>
              ) : (
                // Switching = a membership-validated re-mint. Different tabs can hold different orgs.
                <button type="button" onClick={() => void selectOrg(org.id)}>
                  מעבר לארגון זה
                </button>
              )}
            </li>
          ))}
        </ul>
      </section>

      <section>
        <h2>הגישה שלכם</h2>
        {me.seatedModules.length === 0 ? (
          <p data-testid="no-seats">עדיין אין לכם מושב באף מוצר.</p>
        ) : (
          <ul>
            {me.seatedModules.map((productId) => (
              <li key={productId} data-testid={`seat-${productId}`}>
                {productId}
                {/* Module roles only mean anything where you hold a seat — mirror that here. */}
                {(me.moduleRoles[productId] ?? []).length > 0 && <span> — {me.moduleRoles[productId]!.join(', ')}</span>}
              </li>
            ))}
          </ul>
        )}
      </section>

      <section>
        <h2>חיבור</h2>
        <button type="button" className="btn-danger" onClick={() => void logout()} data-testid="logout">
          התנתקות
        </button>
      </section>
    </div>
  );
}
